import { defineMessages } from 'react-intl';

type MessageKeys = 'removeAgentLabel';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> = defineMessages({
	removeAgentLabel: {
		id: 'ai-mate.inline-chat-input.remove-agent',
		defaultMessage: 'Remove agent',
		description:
			'Accessible label for X button that removes the agent from the chat input on click',
	},
});

export default message;
